import { InventoryType } from '@scaleaq/sitecontrol-lib';

const UNDERWATER_CAMERA_TYPE_LABELS: Readonly<Record<string, string>> = {
  [InventoryType.OrbitFhdUnderwaterCamera]: 'FHD UW Camera',
  [InventoryType.OrbitHdUnderwaterCamera]: 'HD UW Camera',
  [InventoryType.OrbitSdUnderwaterCamera]: 'SD UW Camera',
};

/** Short label for Orbit underwater cameras. Other types are returned unchanged. */
export const labelForDeviceType = (type: string | undefined): string =>
  type ? (UNDERWATER_CAMERA_TYPE_LABELS[type] ?? type) : '';
